import React from "react";
import { useTranslation } from "react-i18next";
import SectionIntro from "./SectionIntro";
import { trackEvent } from "../lib/analytics";

// Official OTA listings for Laurier Rose, Ourika.
const platforms = [
  {
    name: "Booking.com",
    url: "https://www.booking.com/hotel/ma/auberge-laurier-rose.html",
  },
  {
    name: "Expedia",
    url: "https://expe.onelink.me/hnLd/5k93nx1a",
  },
  {
    name: "Agoda",
    url: "https://www.agoda.com/laurier-rose/hotel/madrid-es.html",
  },
  {
    name: "Hostelworld",
    url: "https://www.hostelworld.com/pwa/hosteldetails.php/laurier-Rose/Al-Haouz/338629",
  },
];

const ReserveOptions = () => {
  const { t } = useTranslation();

  return (
    <div>
      <SectionIntro
        eyebrow={t("reserveOptions.eyebrow")}
        title={t("reserveOptions.title")}
        lead={t("reserveOptions.lead")}
        className="mb-10 md:mb-12"
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 max-w-4xl mx-auto">
        {platforms.map((p) => (
          <a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("reserve_click", { platform: p.name })}
            aria-label={t("reserveOptions.bookOn", { platform: p.name })}
            className="group flex items-center justify-between gap-3 border border-ink/15 bg-cream px-5 py-5 hover:border-brass hover:-translate-y-0.5 transition-all duration-300"
          >
            <span className="font-serif text-lg text-ink group-hover:text-brass transition-colors duration-300">
              {p.name}
            </span>
            <svg
              className="w-4 h-4 text-ink-muted group-hover:text-brass transition-colors duration-300 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7 17L17 7M17 7H8M17 7v9"
              />
            </svg>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ReserveOptions;
